module.exports = __webpack_public_path__ + "static/media/country_cg.7749b3f0.webp";